<script lang="ts">
	import type { Component } from 'svelte';
	import SectionRenderer from './SectionRenderer.svelte';
	import EventGalleryBlock from '@comp/block/EventGalleryBlock.svelte';
	import type { FrontPageBlocksData } from '$lib/queries/BlockQueries';
	import LargeText from '@comp/LargeText.svelte';
	import HighlightBlock from '@comp/block/HighlightBlock.svelte';
	import MotionBlock from '@comp/block/MotionBlock.svelte';
	import ShowMeWhatBlock from '@comp/block/ShowMeWhatBlock.svelte';

	let {
		blocks,
		caller
	}: {
		blocks: FrontPageBlocksData;
		caller?: string;
	} = $props();

	const firstBlock = blocks[0];
	if (firstBlock._modelApiKey === 'event_gallery') {
		firstBlock.asHero = true;
	}

	const sectionMap = new Map<string, Component<any>>();

	sectionMap.set('event_gallery', EventGalleryBlock);
	sectionMap.set('large_text', LargeText);
	sectionMap.set('header_block', HighlightBlock);
	sectionMap.set('motion_block', MotionBlock);
	sectionMap.set('show_me_what', ShowMeWhatBlock);
</script>

<SectionRenderer sections={blocks} caller={caller || 'FrontPageSections'} {sectionMap} />
